export class AuditLoginModel {
    constructor(
        public employee_id: any,
        public login: any,
        public login_ip: string,
        public network_id: string,
        public email: string,
        public loggedinTime: string
    ) { }
}
